import type { Profile } from '@/engine/types';

/** Encendida solo con la marca Y la fecha del consentimiento: sin fecha no hay consentimiento. */
export function isLlmOn(profile: Profile): boolean {
  return profile.llmEnabled === true && profile.llmConsentAt != null;
}
